import { render, staticRenderFns } from "./watch-list.vue?vue&type=template&id=09b2f68c&scoped=true"
import script from "./watch-list.vue?vue&type=script&lang=js"
export * from "./watch-list.vue?vue&type=script&lang=js"
import style0 from "./watch-list.vue?vue&type=style&index=0&id=09b2f68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b2f68c",
  null
  
)

export default component.exports